import { render } from "./CommunicationReadySendContainer.vue?vue&type=template&id=2960c8b6&scoped=true&ts=true"
import script from "./CommunicationReadySendContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationReadySendContainer.vue?vue&type=script&lang=ts"

import "./CommunicationReadySendContainer.vue?vue&type=style&index=0&id=2960c8b6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2960c8b6"]])

export default __exports__